import {FmlxAlert} from 'fmlx-common-ui';
import {BannerActionTypes} from '../../constants/actionType';

export const showBanner =
  (severity, title, options = {}) =>
  (dispatch) => {
    dispatch({
      type: BannerActionTypes.SHOW_BANNER,
      severity,
      title,
      textAlign: options.textAlign || FmlxAlert.TextAlign.CENTER,
    });
  };

export const hideBanner = () => ({type: BannerActionTypes.HIDE_BANNER});
